module.exports = __webpack_public_path__ + "assets/img/b30a60d3ef735e3a1a7bff69b315d79c.svg";